// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const AllyDownload = createSvgIcon(
  { All: <React.Fragment><path fill="currentColor" stroke="transparent" fillRule="evenodd" d="M3.9204 16H0L7.9992 4.8291 16 16h-3.8268c-.7084-1.4635-2.2895-2.4827-4.1263-2.4827-1.8369 0-3.4181 1.0192-4.1265 2.4827zm4.0788-6.9153c-1.052 0-1.9051.7938-1.9051 1.773s.853 1.7731 1.905 1.7731 1.905-.7939 1.905-1.7731c0-.9792-.853-1.773-1.905-1.773zM16 3.0857h-2V0h-2.6667v3.0857h-2l3.3334 5.1429L16 3.0857z" clipRule="evenodd" /></React.Fragment>, },
  'small'
);
